<template>
  <!-- 货物品类 -->
  <div class="containerbox serverContent">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="itemBtn btnColor glo_bgcMainColor" @click="addServe()"
          >新建</el-button
        >
        <el-button class="itemBtn btnColor" @click="qiYongMore"
          >批量启用</el-button
        >
        <el-button class="itemBtn btnColor" @click="jinYongMore"
          >批量禁用</el-button
        >
        <el-button class="itemBtn btnColor" @click="setMyTable()"
          >表格设置</el-button
        >
        <!-- <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <!-- <el-button class="itemBtn btnColor" @click="DelServe()">删除</el-button> -->
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        :showMoreBtns="false"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <el-form-item class="queryItems" label="品类名称:">
          <el-input
            clearable
            v-model="queryData.categoryName"
            placeholder="请输入"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="品类类型:">
          <el-select
            v-model="queryData.typeName"
            clearable
            placeholder="请输入关键词"
            filterable
            remote
            :loading="false"
            :remote-method="remoteMethod2"
            @change="changeTypeName1"
          >
            <el-option
              v-for="(item, index) in CategoryTypeList"
              :key="index"
              :label="item.typeName"
              :value="item.typeName"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格:height="tableHeigth" -->
    <div class="glo_Table" ref="tableWrapper">
      <el-table
        ref="mytable"
        :data="tableData"
        :height="tableHeigth"
        :row-class-name="tableRowClassName"
        highlight-current-row
        @row-click="rowclick"
        :header-cell-style="{ background: '#f0f0f0' }"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column fixed="left" label="序号" type="index" width="60">
        </el-table-column>
        <el-table-column fixed="left" type="selection" width="60">
        </el-table-column>

        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            sortable
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item.field == 'isShowShow'"
          >
            <template slot-scope="scope">
              <div style="color: #f00" v-if="scope.row.isShow == '0'">禁用</div>
              <div v-else>启用</div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          >
          </el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="220px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="editorServe(scope.row)"
                >编辑</el-button
              >
              <el-button
                class="rbtns"
                @click.stop="qiYong(scope.row.itemCategoryId)"
                >启用</el-button
              >
              <el-button
                class="rbtns"
                @click.stop="jinYong(scope.row.itemCategoryId)"
                >禁用</el-button
              >
              <el-button
                class="rbtns"
                @click.stop="DelServe(scope.row.itemCategoryId)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页组件 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :sizeList="sizeList"
      :size="pageTotal"
      class="serverPage"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>

    <!-- 弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog"
          ref="dialogFormRef"
          :model="dialogForm"
          label-width="100px"
          :rules="rulesForm"
        >
          <el-form-item
            class="dialogFormItems"
            prop="itemCategoryName"
            label="品类名称:"
          >
            <el-input v-model="dialogForm.itemCategoryName"></el-input>
          </el-form-item>

          <el-form-item
            class="dialogFormItems"
            prop="channelItemcategoryTypeId"
            label="所属类型:"
          >
            <el-select
              v-model="dialogForm.channelItemcategoryTypeId"
              clearable
              placeholder="请输入关键词"
              filterable
              remote
              :loading="false"
              :remote-method="remoteMethod2"
              @change="changeTypeName"
            >
              <el-option
                v-for="(item, index) in CategoryTypeList"
                :key="index"
                :label="item.typeName"
                :value="item.typeId + ''"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="sort" label="排序:">
            <el-input v-model="dialogForm.sort"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="isShow" label="启用状态:">
            <el-select
              filterable
              clearable
              v-model="dialogForm.isShow"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in isShowList"
                :key="index"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="comment" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.comment"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    >
    </sorttable>
  </div>
</template>

<script>
// import { apiList, this.$API } from "@/assets/js/api";
// import tools from "@/assets/js/tool";
import paging from "@/components/pagings.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
export default {
  inject: ["reload"],
  components: {
    queryBtns,
    myDialog,
    paging,
    uploadimgs,
    sorttable,
  },
  data() {
    return {
      pageStart: 1, //页码
      pageTotal: this.$COMMON.pageTotals, //一页几条,
      pageCount: 0, //总条数
      sizeList: [10, 20, 50, 100, 200],
      tableHeigth: "75vh",
      selectTableData: [],

      queryData: { categoryName: "", typeName: "" },
      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      diaWidth: "40%",
      dialogForm: {
        // 弹窗表单数据
        channelItemcategoryTypeId: "",
        comment: "",
        isShow: "1",
        itemCategoryName: "",
        sort: "1",
      },
      rulesForm: {
        isShow: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        itemCategoryName: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },

      // 默认表头
      tabelHeadeTitle: [
        {
          name: "编号",
          field: "itemCategoryCode",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "品类名称",
          field: "itemCategoryName",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "品类类型",
          field: "channelItemcategoryTypeName",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "排序",
          field: "sort",
          width: "100",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "状态",
          field: "isShowShow",
          width: "120",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "备注",
          field: "comment",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "新建人",
          field: "creatorUserName",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "新建时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "修改人",
          field: "updateUserName",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "修改时间",
          field: "updateTime",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      myTableHeard: [], //  我的表头
      tableData: [],

      show_sortTableHeard: false, //显示表格设置弹窗
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      allCheck: false, //  全选
      sortName: "货物品类模板", //  排序名
      pageGroupName: "GoodsCategory",
      selectLength: 0, //  显示的长度
      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      CategoryTypeList: [],
      isShowList: [
        {
          name: "启用",
          val: "1",
        },
        {
          name: "禁用",
          val: "0",
        },
      ],
      dialogType: "add",
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle;
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }

    //获取默认表头 页面有这四个字段 myTableHeard,sortName,tabelHeadeTitle,totalArr
    this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
  },
  mounted() {
    this.getData();
    this.remoteMethod2();
  },
  activated() {},
  watch: {},
  methods: {
    // 批量启用
    qiYongMore() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请选择需要操作的数据");
        return false;
      }
      this.$confirm("是否启用所选数据?", "提示:")
        .then((respon) => {
          let ids = [];
          this.selectTableData.forEach((item) => {
            ids.push(item.itemCategoryId);
          });
          this.$API.wtl_startCategory({ itemCategoryIds: ids }).then((res) => {
            this.$message.success(res.data.message || "启用成功");
            this.getData();
          });
        })
        .catch((error) => {});
    },
    // 批量禁用
    jinYongMore() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请选择需要操作的数据");
        return false;
      }
      this.$confirm("是否禁用所选数据?", "提示:")
        .then((respon) => {
          let ids = [];
          this.selectTableData.forEach((item) => {
            ids.push(item.itemCategoryId);
          });
          this.$API.wtl_stopCategory({ itemCategoryIds: ids }).then((res) => {
            this.$message.success(res.data.message || "禁用成功");
            this.getData();
          });
        })
        .catch((error) => {});
    },
    // 启用
    qiYong(id) {
      this.$confirm("是否启用所选数据?", "提示:")
        .then((respon) => {
          let ids = [id];
          this.$API.wtl_startCategory({ itemCategoryIds: ids }).then((res) => {
            this.$message.success(res.data.message || "启用成功");
            this.getData();
          });
        })
        .catch((error) => {});
    },
    // 禁用
    jinYong(id) {
      this.$confirm("是否禁用所选数据?", "提示:")
        .then((respon) => {
          let ids = [id];
          this.$API.wtl_stopCategory({ itemCategoryIds: ids }).then((res) => {
            this.$message.success(res.data.message || "禁用成功");
            this.getData();
          });
        })
        .catch((error) => {});
    },

    // 删除
    DelServe(id) {
      this.$confirm("是否删除所选数据?!", "提示:")
        .then((res) => {
          let ids = [id];
          let param = {
            itemCategoryIds: ids,
          };
          this.$API.wtl_delCategory(param).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch(() => {});
    },

    // 获取品类类型
    remoteMethod2(typeName, parentName) {
      let param = {
        parentName: parentName || "",
        typeName: typeName || "",
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
      };
      this.$API.wtl_getCategoryTypeList(param).then((res) => {
        if (res.data.status == "success") {
          this.CategoryTypeList = res.data.result.data || [];
        }
      });
    },
    // 查询条件
    changeTypeName1(e) {
      if (!e) {
        this.remoteMethod2();
      }
      this.queryBtn_ok();
    },
    changeTypeName(e) {
      if (!e) {
        this.remoteMethod2();
      }
    },

    // 表格设置
    setMyTable() {
      console.log("setMyTable");
      this.$TOOLS.myModel(this);
    },
    //顶部跟多按钮的操作
    // topCommandBtns(a) {
    //   if (a === "bgsz") {
    //     // 设置模板按钮
    //     // this.myModel();
    //     this.$TOOLS.myModel(this);
    //   }
    //   if (a === "dyyd") {
    //     // 打印运单
    //   }
    //   if (a === "dybq") {
    //     // 打印标签
    //   }
    //   if (a === "dr") {
    //     // 导入
    //   }
    //   if (a === "dc") {
    //     // 导出
    //   }
    // },
    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },

    clerBtns() {
      //  重置按钮
      this.queryData = { categoryName: "", typeName: "" };
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },

    // 新建
    addServe() {
      this.isShowDialog = true;
      this.dialogTitle = "新建品类";
      this.dialogType = "add";
      this.remoteMethod2();
    },
    // 编辑
    editorServe(row) {
      this.remoteMethod2();
      console.log(row);
      this.dialogForm = row;
      this.dialogForm.isShow = row.isShow + "";
      this.dialogForm.channelItemcategoryTypeId =
        row.channelItemcategoryTypeId + "";

      this.isShowDialog = true;
      this.dialogTitle = "编辑品类";
      this.dialogType = "edit";
    },

    //=>选择表格操作
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    //表格样式i
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
    },
    /**
     * ******************************计算表格高度**开始*************************
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },
    /**
     * ******************************计算表格高度**结束*************************
     */

    //分页
    handleSizeChange(val) {
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.getData();
    },
    // 获取数据
    getData() {
      let that = this;
      let param = {
        categoryName: this.queryData.categoryName,
        typeName: this.queryData.typeName,
        pageStart: this.queryData.pageStart,
        pageTotal: this.queryData.pageTotal,
      };
      this.$API.wtl_getCategoryList(param).then((res) => {
        that.tableData = res.data.result.data || [];
        that.pageCount = res.data.result.pageCount || 0;
        that.$nextTick(() => {
          that.fetTableHeight();
        });
      });
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.dialogForm = {
        channelItemcategoryTypeId: "",
        comment: "",
        isShow: "1",
        itemCategoryName: "",
        sort: "1",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isShowDialog = false;
          let param = {
            channelItemcategoryTypeId:
              this.dialogForm.channelItemcategoryTypeId || "",
            comment: this.dialogForm.comment || "",
            isShow: this.dialogForm.isShow || "0",
            itemCategoryName: this.dialogForm.itemCategoryName || "",
            sort: this.dialogForm.sort || "1",
          };
          if (this.dialogType == "add") {
            // 新建
            this.$API.wtl_addCategory(param).then((res) => {
              this.$message.success(res.data.message || "新建成功");
              this.getData();
            });
          } else {
            // 编辑
            param.itemCategoryId = this.dialogForm.itemCategoryId || "";
            this.$API.wtl_udpateCategory(param).then((res) => {
              this.$message.success(res.data.message || "修改成功");
              this.getData();
            });
          }
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // ===================排序表头彈窗的组件方法 start ===================
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    /****
     *  ===================排序表头彈窗的组件方法 end ===================
     *
     */
  },
};
</script>

<style scoped lang="less">
// .containerbox {
//   height: calc(100vh - 75px);
// }

// .tableBox {
//   height: calc(100% - 180px);
// }
.colorStyle {
  color: #f00;
}
.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}
.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }
  .timeBox {
    border: 1px solid #d7d7d7;
  }
}
.headerbox {
  width: 100%;
  display: flex;
  justify-content: center;
}
.imgbox {
  width: 100%;
  margin-left: 12%;
  box-sizing: border-box;
}
.footerbox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.newForm {
  margin-left: 80px;
  .queryItem1 {
    width: 60%;
    margin-top: 20px;
  }
}
.singleinp1 {
  min-width: 392px;
}
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input,
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input__inner {
  width: 100%;
}
.SingleChoicebox {
  width: 100%;
  padding: 0 20px;
  margin-top: 20px;
  box-sizing: border-box;
}
.el-input-number {
  width: 100%;
  height: 30px;
  line-height: 30px;
}
.serverContent {
  .tableBox {
    background-color: #fff;
  }
  .btnList1 {
    width: auto;
    // padding: 10px;
    border-radius: 4px;
  }
}
</style>
